import { PlanItem } from "@dto/PlanItem";
import { FunctionComponent, useMemo } from "react";
import { PlanItem as PlanItemView } from "../../entities/PlanItemList/PlanItem";
import { useAppSelector } from "@store/store";
import { selectDirections } from "@store/planRouteReducer";
import { PlanItemTravelIndicator } from "@modules/entities/PlanItemList/PlanItemTravelIndicator";
interface UserPlanItemProps {
  planItem: PlanItem;
  ordinal: number;
  actionsEnabled?: boolean;
}

/**
 * Display plan item with directions
 */
const UserPlanItem: FunctionComponent<UserPlanItemProps> = ({
  planItem,
  ordinal,
}) => {
  const directions = useAppSelector(selectDirections);

  const direction = useMemo(() => {
    return directions?.find((x) => {
      const lastItem = x.start.items[x.start.items.length - 1];
      if (lastItem?.id !== planItem.id) {
        return false;
      }

      if (x.end.items[0].dayIndex !== planItem.dayIndex) {
        // Do not show directions when it crosses days.
        return false;
      }

      return true;
    });
  }, [directions, planItem.id, planItem.dayIndex]);

  console.log(direction);

  return (
    <>
      <PlanItemView
        planItem={planItem}
        ordinal={ordinal}
        actionsEnabled={true}
      />
      <PlanItemTravelIndicator
        distanceInMeters={direction?.distanceInMeters}
        timeInSeconds={direction?.timeInSeconds}
      />
    </>
  );
};

export { UserPlanItem };
